import React from "react";
import "./BlogCard.css";
import "./BlogList.css";

interface BlogCardProps {
    title: string;
    excerpt: string;
    author: string;
    date?: string;
    imageUrl?: string;
    category?: string;
    onReadClick?: () => void;
}

const BlogCard: React.FC<BlogCardProps> = ({
    title,
    excerpt, // still here but unused (you can remove later if not needed)
    author,
    date = new Date().toLocaleDateString(),
    imageUrl,
    category,
    onReadClick
}) => {
    return (
        <section className="blog-card">
            {imageUrl && (
                <div className="blog-card__image-container">
                    <img src={imageUrl} alt={title} className="blog-card__image" />
                </div>
            )}

            <div className="blog-card__content">
                <h2 className="blog-card__title">{title}</h2>

                {/* 🔥 REMOVED EXCERPT HERE */}

                <div className="blog-card__meta">
                    <span className="blog-card__author">By {author}</span>
                    <span className="blog-card__date">{date}</span>
                </div>

                {onReadClick && (
                    <button className="blog-card__read-button" onClick={onReadClick}>
                        Read More
                    </button>
                )}
            </div>
        </section>
    );
};

export default BlogCard;
